const maxCharactersTitleStorePreview = 20;
const maxCharactersDescriptionStorePreview = 23;
export const getTextExcerpt = (text, isDescription = false) => {
    const maxChars = isDescription
        ? maxCharactersDescriptionStorePreview
        : maxCharactersTitleStorePreview;
    return text.length > maxChars ? `${text.substring(0, maxChars).trim()}...` : text;
};
export const normalize = (input) => {
    return input.normalize('NFC').normalize('NFKC');
};
//# sourceMappingURL=strings.js.map